// @flow

import type { ComponentType } from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { notifyDanger } from '@gandi/notifications';
import { contactbook } from '@gandi/redux-resource-contactbook';
import { actions as templateActions } from '@gandi/template2';

import { withLogger } from 'gandi.redux-logger';

import { withRouter } from 'src/helpers/withRouter';

import type { FullState, MapDispatchToProps } from '../../../types';
import { ensureCorporatePack } from '../../AccountChoice/modules/actions';
import { getBaseContact } from '../../DomainContacts/Wizard/modules/actions';
import { cleanUpAllDrafts, updateDomainsPayload } from '../modules/actions';
import {
  selectHasDomainCreate,
  selectHasDomainTransfer,
  selectIsPayloadInvalid,
  selectSetupOwner,
  selectShouldFetchFavoriteContacts,
  selectHasCreateDraft,
  selectHasTransferDraft,
  selectShouldFetchOneDefaultTemplate,
  selectShouldFetchOwnerExtraParams,
} from '../modules/selectors';

import Presenter from './Presenter';
import type { StateProps, DispatchProps } from './Presenter';

const mapStateToProps = (state: FullState): StateProps => {
  const setupOwner = selectSetupOwner(state);
  const hasDomainCreate = selectHasDomainCreate(state);
  const hasDomainTransfer = selectHasDomainTransfer(state);

  return {
    hasDomainCreate,
    hasDomainTransfer,

    isPayloadInvalid: selectIsPayloadInvalid(state),
    shouldFetchFavoriteContacts: selectShouldFetchFavoriteContacts(
      state,
      setupOwner,
    ),
    hasCreateDraft: selectHasCreateDraft(state),
    hasTransferDraft: selectHasTransferDraft(state),
    setupOwner,
    shouldFetchDefaultTemplateCreate:
      hasDomainCreate &&
      selectShouldFetchOneDefaultTemplate(state, {
        productType: 'domain',
        process: 'create',
        sharingId: setupOwner,
      }),
    shouldFetchDefaultTemplateTransfer:
      hasDomainTransfer &&
      selectShouldFetchOneDefaultTemplate(state, {
        productType: 'domain',
        process: 'transfer',
        sharingId: setupOwner,
      }),
    shouldFetchOwnerExtraParams: selectShouldFetchOwnerExtraParams(state, {
      orgId: setupOwner,
    }),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps> = {
  cleanUpAllDrafts,
  getBaseContact,
  ensureCorporatePack,
  notifyDanger,
  updateDomainsPayload,
  fetchOwnerContactExtraParams: contactbook.fetchOwnerContactExtraParams,
  fetchDefaultTemplate: templateActions.fetchDefaultTemplate,
};

export default (compose(
  withLogger('BatchOverview/Presenter'),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): ComponentType<{ ... }> & {
  preFetch: mixed => null | Promise<mixed>,
});
